import { motion } from 'framer-motion';
import { SunIcon } from '@heroicons/react/24/outline';
import { Button } from '../../ui';
import { useAuthStore } from '../../../stores/authStore';

interface MorningWelcomeProps {
  onStart: () => void;
  onSkip: () => void;
}

export function MorningWelcome({ onStart, onSkip }: MorningWelcomeProps) {
  const { user } = useAuthStore();
  const firstName = user?.displayName?.split(' ')[0] || 'Friend';

  const hour = new Date().getHours();
  const greeting =
    hour < 12
      ? 'Good morning'
      : hour < 17
        ? 'Good afternoon'
        : 'Good evening';

  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mb-6">
        <SunIcon className="w-8 h-8 text-white" />
      </div>

      <h1 className="font-display text-3xl font-semibold text-surface-800 dark:text-white mb-2">
        {greeting}, {firstName}!
      </h1>

      <p className="text-surface-600 dark:text-surface-400 mb-8 max-w-md">
        Let's set intentions for your day.
      </p>

      <div className="bg-surface-100 dark:bg-surface-800 rounded-xl p-6 mb-8 max-w-md">
        <p className="text-sm text-surface-600 dark:text-surface-400 mb-3">
          This morning's check-in:
        </p>
        <ul className="text-left space-y-2 text-surface-700 dark:text-surface-300">
          <li className="flex items-center gap-2">
            <span className="text-accent-500">•</span> 3 minutes
          </li>
          <li className="flex items-center gap-2">
            <span className="text-accent-500">•</span> 5 questions
          </li>
          <li className="flex items-center gap-2">
            <span className="text-accent-500">•</span> Share with your sponsors
          </li>
        </ul>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
        <Button onClick={onStart} size="lg" className="flex-1">
          Start Check-in
        </Button>
        <Button onClick={onSkip} variant="ghost" size="lg">
          Skip Today
        </Button>
      </div>
    </motion.div>
  );
}
